export default "__VITE_ASSET__MlFO3Sr6__"